// Admin-portal date/time formatting: always YYYY-MM-DD in Korea Standard Time,
// with the literal "KST" shown, e.g. "2026-08-07 - 11:59:20 AM KST".
//
// Accepts a Date, epoch milliseconds, epoch seconds, or an ISO-8601 string.
// Epoch seconds vs milliseconds is disambiguated by magnitude (values below
// 1e12 are treated as seconds; 1e12 ms is year 2001, and epoch-seconds now are
// ~1.7e9, so the split is unambiguous for any realistic timestamp).

const toDate = (value) => {
    if (value == null || value === "") return null;
    if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
    if (typeof value === "number") {
        return new Date(value < 1e12 ? value * 1000 : value);
    }
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
};

const DATE_FMT = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Seoul",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
}); // en-CA yields YYYY-MM-DD

const TIME_FMT = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Seoul",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
});

/**
 * Format a timestamp as "YYYY-MM-DD - hh:mm:ss AM/PM KST" (Asia/Seoul).
 * Returns `fallback` (default "-") for null/unparseable input.
 */
export const formatKst = (value, fallback = "-") => {
    const d = toDate(value);
    if (!d) return fallback;
    return `${DATE_FMT.format(d)} - ${TIME_FMT.format(d)} KST`;
};

/**
 * Date-only variant: "YYYY-MM-DD" in Asia/Seoul (no time, no KST label).
 */
export const formatKstDate = (value, fallback = "-") => {
    const d = toDate(value);
    if (!d) return fallback;
    return DATE_FMT.format(d);
};

export default formatKst;
